import { cva, type VariantProps } from "class-variance-authority";
import React, { type ButtonHTMLAttributes } from "react";
import { cn } from "../../../lib/utils/cn";

export const ButtonVariants = cva(
  `py-[10px] px-[20px] rounded-[10px] flex-row justify-center cursor-pointer font-[500] text-sm focus:outline-none focus-visible:outline-none`,
  {
    variants: {
      variant: {
        white: "bg-[#fff] border border-[#e6e6e6]",
        primary: "bg-primary text-[#fff] border-primary border",
        blue: "bg-[#0A8AF9] text-[#fff]",
        disblue: "bg-[#BFDFFC] text-[#fff] text-[#fff]",
        gray: "bg-[#F2F3F5]",
        kakao: "bg-[#FEE500]",
        disabled: "bg-[#e6e6e6] text-[#888]",
        black: "bg-[#222] text-[#fff] border",
        red: "bg-[#e5002b] text-[#fff]",
        selected: "bg-[#fff] border border-[#222]",
      },
      size: {
        default: "",
        md: "h-[56px] w-[130px]",
        sm: "h-[48px] w-[120px]",
      },
    },
    defaultVariants: {},
  },
);

interface ButtonProps
  extends
    ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof ButtonVariants> {
  children?: React.ReactNode;
  label?: string;
}

export default function Button({
  className,
  variant,
  size,
  children,
  label,
  onClick,
  ...props
}: ButtonProps) {
  const [internalDisabled, setInternalDisabled] = React.useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClick) return;

    setInternalDisabled(true);

    Promise.resolve(onClick(e))
      .catch((err) => {
        console.error("버튼 클릭 에러:", err);
      })
      .finally(() => {
        setInternalDisabled(false);
      });
  };

  return (
    <button
      className={cn(
        ButtonVariants({ variant, size }),
        className,
        "disabled:bg-gray-100 disabled:text-gray-400",
      )}
      disabled={internalDisabled || props.disabled}
      onClick={handleClick}
      {...props}
    >
      {children && children}
      {label ? label : children ? "" : "확인"}
    </button>
  );
}
